<template>
  <div class="cart-price-card">
    <div class="detail-list">
      <div>購入：</div>
      <div class="sub-total right">¥{{ $n(order && order.not_request_subtotal_sales_price_without_tax) }}</div>
      <div>リクエスト：</div>
      <div class="sub-total right">¥{{ $n(order && order.request_subtotal_sales_price_without_tax) }}</div>
    </div>
    <div class="total-price align-baseline">
      <div>合計金額：</div>
      <div class="number"><span class="unit">¥</span>{{ $n(order && order.subtotal_sales_price_without_tax)
      }}<span class="delivery-fee">（内送料¥{{ $n(order && order.subtotal_delivery_fee) }}）</span></div>
    </div>
    <Button v-bind:class="{ 'line-order_complete': $t('complete_order') === buttonText }" size="big" block class="mt-5"
      :disabled="isDisabled" :to="buttonTo" @click="$emit('button-click')">
      {{ buttonText }}
    </Button>
  </div>
</template>

<script>
import Button from "@/components/shop/Button.vue";

export default {
  components: {
    Button
  },

  props: {
    order: {
      type: Object,
      default: null
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonTo: {
      type: String,
      default: ""
    }
  },

  computed: {
    isDisabled() {
      const now = new Date();

      if (this.order) {
        for (let i = 0; i < this.order.order_items.length; i++) {
          const orderItem = this.order.order_items[i];
          const deliveryDate = new Date(orderItem.delivery_date);

          if (deliveryDate < now) {
            return true;
          }
        }
      }

      return !this.order || !this.order.order_items.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.cart-price-card {
  background-color: #fff;
  border: #ccc 1px solid;
  border-radius: 5px;
  padding: 16px;
}

.detail-list {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  grid-gap: 4px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #cccccc;
  font-size: 18px;
  font-weight: bold;
  color: #555;

  .sub-total {
    overflow-wrap: anywhere
  }

  .right {
    justify-self: end;
  }
}

.total-price {
  margin-top: 12px;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  font-size: 18px;
  font-weight: bold;
  color: #ff8c71;
  line-height: 1.2;
  overflow-wrap: anywhere;

  .number {
    font-size: 20px;
    line-height: 24px;
  }

  .unit {
    font-size: 18px;
    line-height: 22px;
  }

  .delivery-fee {
    font-size: 14px;
    line-height: 17px;
  }
}
</style>
